import React, { useState } from 'react';
import './ItemModal.css';

const isRoll = p => p.foodName?.toLowerCase().includes('roll');

// Small/mini plain rolls are only sold by the half dozen. The item's minQty from
// the API is the source of truth; the name check only covers items that predate
// that field or an API that hasn't sent it.
const SMALL_WORDS = ['small', 'mini'];
const legacyMinQtyFor = p => {
  const name = (p.foodName ?? '').toLowerCase();
  const size = (p.size ?? '').toLowerCase().trim();
  const isSmall = SMALL_WORDS.includes(size) || SMALL_WORDS.some(w => name.includes(w));
  return name.includes('plain roll') && isSmall ? 6 : 1;
};
export const minQtyFor = p => {
  const fromApi = Number(p.minQty);
  if (p.minQty != null && Number.isInteger(fromApi) && fromApi >= 1) return fromApi;
  return legacyMinQtyFor(p);
};
const maxQtyFor = p => Math.max(isRoll(p) ? 30 : 10, minQtyFor(p));

const ItemModal = ({ item, existingQty, onClose, onAddToCart }) => {
  const min = minQtyFor(item);
  const max = maxQtyFor(item);
  const [qty, setQty] = useState(existingQty || min);

  const dec = () => setQty(q => Math.max(min, q - 1));
  const inc = () => setQty(q => Math.min(max, q + 1));

  const handleAdd = () => {
    onAddToCart({ ...item, quantity: qty, minQty: min, maxQty: max });
    onClose();
  };

  return (
    <div className="item-modal-overlay" onClick={onClose}>
      <div className="item-modal" onClick={e => e.stopPropagation()}>
        <button className="item-modal-close" onClick={onClose}>×</button>

        {item.imageUrl && (
          <img src={item.imageUrl} alt={item.foodName} className="item-modal-image" />
        )}

        <div className="item-modal-info">
          <h2>{item.size} {item.foodName}</h2>
          <p className="item-modal-price">${item.price.toFixed(2)} each</p>
          {min > 1 && <p className="item-modal-min">Minimum order: {min}</p>}
        </div>

        <div className="item-modal-qty-row">
          <button className="qty-btn" onClick={dec} disabled={qty <= min}>–</button>
          <span className="qty-value">{qty}</span>
          <button className="qty-btn" onClick={inc} disabled={qty >= max}>+</button>
        </div>

        <button className="item-modal-add-btn" onClick={handleAdd}>
          {existingQty ? 'Update Cart' : 'Add to Cart'} · ${(item.price * qty).toFixed(2)}
        </button>
      </div>
    </div>
  );
};

export default ItemModal;
